/** A period the bookkeeper's export can cover: a month, a quarter or a year. */
export type ExportMode = 'month' | 'quarter' | 'year';

export interface ExportPeriod {
  mode: ExportMode;
  /** YYYY-MM, inclusive both ends. */
  from: string;
  to: string;
  /** "2026-08", "2026-Q3", "2026": what the file is named after. */
  label: string;
}

const pad = (value: number) => String(value).padStart(2, '0');

export const periodOf = (mode: ExportMode, month: string): ExportPeriod => {
  const year = Number(month.slice(0, 4));
  const m = Number(month.slice(5, 7));
  if (mode === 'year') return { mode, from: `${year}-01`, to: `${year}-12`, label: String(year) };
  if (mode === 'quarter') {
    const quarter = Math.ceil(m / 3);
    return { mode, from: `${year}-${pad(quarter * 3 - 2)}`, to: `${year}-${pad(quarter * 3)}`, label: `${year}-Q${quarter}` };
  }
  return { mode, from: month, to: month, label: month };
};

/** Steps the period by one of its own length, keeping the month it is anchored on in it. */
export const shiftPeriod = (mode: ExportMode, month: string, delta: number): string => {
  const months = mode === 'year' ? 12 : mode === 'quarter' ? 3 : 1;
  const index = Number(month.slice(0, 4)) * 12 + Number(month.slice(5, 7)) - 1 + delta * months;
  return `${Math.floor(index / 12)}-${pad((index % 12) + 1)}`;
};

/** As the server names it: letters and digits of the kindergarten's name, joined by "_". */
export const exportFileName = (kindergartenName: string, period: ExportPeriod) =>
  `${(kindergartenName || 'vrtic').replace(/[^\p{L}\p{N}]+/gu, '_').replace(/^_|_$/g, '')}_finansije_${period.label}.xlsx`;
